import eventMixin from '../lib/mixins/event';
import Logger from '../lib/logger';

export default class ThemeSingleImageCarousel {
	constructor(dom) {
		// Vars
		// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
		this.NAME              = 'THEME SINGLE IMAGE CAROUSEL';
		this.dom               = dom;
		this.next_btn          = this.dom.querySelector(`[data-theme-single-image-carousel-button]`);
		this.slider            = this.dom.querySelector(`[data-theme-single-image-carousel-slider]`);
		this.slides            = this.dom.querySelectorAll(`[data-theme-single-image-carousel-slide]`);
		this.current           = null;
		this.animation_timeout = null;
	};

	// Logic
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	init() {
		Logger.info(`${this.NAME} > init`);
		const self = this;

		if (this.slides) {
			this.current = 0;
		} else this.next_btn = null

		this.addHandlers();
	}

	addHandlers() {
		Logger.info(`${this.NAME} > addHandlers`);
		this.next_btn?.addEventListener('mousedown', this.onSlider.bind(this));
	}

	onSlider() {

		const self = this;
		if (this.slides.length <= 0) return;

		Logger.info(`${this.NAME} > onSlider > Slides: ${this.slides.length} > Current: ${this.slides[this.current].id}`);

		this.slides[this.current].classList.remove('theme-single-image-carousel__slide--current');

		if (this.current === this.slides.length - 1) {
			this.current = 0;
		} else {
			this.current++;
		}

		Logger.log(`${this.NAME} > onSlider > Slide: ${this.slides[this.current].id}`);
		this.slides[this.current].classList.add('theme-single-image-carousel__slide--current');

		this.slider.style.animationName = "none";

		requestAnimationFrame(() => {
			setTimeout(() => {
				self.slider.style.animationName = ""
			}, 0);
		});

	}
}

// Mixins
Object.assign(ThemeSingleImageCarousel.prototype, eventMixin);
